/* ------------------------------------------------------------------------------
 *
 *  # DataTables Integration
 *
 *  Generic DataTables functionality and configuration
 *
 * ---------------------------------------------------------------------------- */

// DataTables Configuration
export function initDataTableDefaults() {
	if (typeof $.fn.dataTable !== 'undefined') {
		$.extend($.fn.dataTable.defaults, {
			autoWidth: false,
			dom: '<"datatable-header justify-content-start"f<"ms-sm-auto"><"ms-sm-3"B>><"datatable-scroll-wrap"t><"datatable-footer"ipl>',
			language: {
				search: '<span class="me-3">Filtro:</span> <div class="form-control-feedback form-control-feedback-end flex-fill">_INPUT_<div class="form-control-feedback-icon"><i class="ph-magnifying-glass opacity-50"></i></div></div>',
				searchPlaceholder: 'Escribe para filtrar...',
				info: 'Mostrando del _START_ al _END_ de _TOTAL_ entradas',
				lengthMenu: '<span class="me-3">Mostrar:</span> _MENU_',
				paginate: { 
					'first': 'Primero', 
					'last': 'Último', 
					'next': document.dir == "rtl" ? '&larr;' : '&rarr;', 
					'previous': document.dir == "rtl" ? '&rarr;' : '&larr;' 
				}
			}
		});
	}
}

// Generic DataTable Functions
export function initGenericDataTable(tableId, options = {}) {
	if (typeof $.fn.dataTable === 'undefined') {
		console.error('DataTables not loaded');
		return null;
	}

	const defaultOptions = {
		responsive: true,
		pageLength: 5,
		lengthMenu: [[5, 25, 50, 100, -1], [5, 25, 50, 100, "Todos"]],
		buttons: [
			{
				extend: 'collection',
				className: 'btn btn-flat-primary btn-labeled btn-labeled-start dropdown-toggle me-3 rounded',
				text: '<span class="btn-labeled-icon bg-primary text-white rounded-start"><i class="ph-export"></i></span>Exportar',
				buttons: [
					{
						extend: 'excel',
						text: '<i class="ph-file-xls me-1"></i>Excel',
						className: 'dropdown-item',
						title: options.exportTitle || 'Exportación de datos',
						exportOptions: {
							columns: ':not(.no-export)',
							format: {
								body: function (data, row, column, node) {
									return $(data).text() || data;
								}
							}
						}
					},
					{
						extend: 'copy',
						text: '<i class="ph-clipboard-text me-1"></i>Copiar',
						className: 'dropdown-item',
					}
				]
			}
		]
	};

	const finalOptions = { ...defaultOptions, ...options };
	
	const table = $(`#${tableId}`).DataTable(finalOptions);
	return table;
}

export function refreshDataTable(tableId, newData = null) {
	const table = $(`#${tableId}`).DataTable();
	if (table) {
		if (newData) {
			table.clear();
			table.rows.add(newData);
		}
		table.draw();
	}
}

export function destroyDataTable(tableId) {
	if ($.fn.DataTable.isDataTable(`#${tableId}`)) {
		$(`#${tableId}`).DataTable().destroy();
	}
}
